<div class="flex items-center justify-between px-4 py-3 border-t border-gray-600 sm:px-6">
    <div class="flex justify-between flex-1 sm:hidden">
        <button (click)="prevPage()" [disabled]="prevDisabled"
            class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700">
            Previous
        </button>
        <button (click)="nextPage()" [disabled]="nextDisabled"
            class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700">
            Next
        </button>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
            <p class="text-xs leading-5 text-gray-700">
                Showing
                <span class="font-medium">{{resultSize}}</span>
                results
            </p>
        </div>
        <div>
            <nav class="relative z-0 inline-flex shadow-sm">
                <button (click)="prevPage()" [disabled]="prevDisabled"
                    class="relative inline-flex items-center px-2 py-2 text-xs font-medium leading-5 text-gray-600 transition duration-150 ease-in-out border border-gray-600 rounded-l-md hover:bg-gray-900 hover:text-gray-30 focus:z-10 focus:outline-none focus:border-gray-700 active:bg-gray-700 active:text-gray-30 disabled:opacity-30"
                    aria-label="Previous">
                    <!-- Heroicon name: chevron-left -->
                    <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    Previous
                </button>

                <button (click)="nextPage()" [disabled]="nextDisabled"
                    class="relative inline-flex items-center px-2 py-2 -ml-px text-xs font-medium leading-5 text-gray-600 transition duration-150 ease-in-out border border-gray-600 rounded-r-md hover:bg-gray-900 hover:text-gray-30 focus:z-10 focus:outline-none focus:border-gray-700 active:bg-gray-700 active:text-gray-30 disabled:opacity-30"
                    aria-label="Next">
                    Next
                    <!-- Heroicon name: chevron-right -->
                    <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                </button>
            </nav>
        </div>
    </div>
</div>